import { onlineManager, QueryClient } from "@tanstack/react-query";
import { pingServer } from "./ping-server";

if (import.meta.env.VITE_CAPACITOR_BUILD === "true") {
	// React query assumes online=true on app load by default. In capacitor builds we need to override this behavior to avoid query errors when loading the app offline.
	onlineManager.setOnline(false);

	onlineManager.setEventListener((setOnline) => {
		// most reliable way to initially check if online is to just ping the server
		pingServer(30)
			.then((ok) => {
				onlineManager.setOnline(ok);
			})
			.catch((error: unknown) => {
				console.error("Initial online check failed", error);
				onlineManager.setOnline(false);
			});

		function handleOnline() {
			setOnline(true);
		}
		function handleOffline() {
			setOnline(false);
		}

		window.addEventListener("online", handleOnline);
		window.addEventListener("offline", handleOffline);

		return () => {
			window.removeEventListener("online", handleOnline);
			window.removeEventListener("offline", handleOffline);
		};
	});
}

export const queryClient = new QueryClient();
